/**
 * HVA EN GRUNN TIL Å FØLGE HETER (0931, punkt 84) — i tråden og i varselet.
 *
 * En tabell av literale nøkler, aldri en template-nøkkel: en ny grunn i basen
 * (`ck_thread_followers__reason`) er en typefeil her framfor en rå nøkkel på skjermen. Se
 * `booking-status.ts` for hvorfor huset gjør det slik.
 */
import type { EngagementDto, ThreadFollowReason } from '@tvitvi/shared';

import type { TKey } from '@/i18n/types';

/** Ved navnet i tråden: «ansvarlig», «nevnt» … */
export const FOLLOW_REASON_LABEL: Readonly<Record<ThreadFollowReason, TKey>> = {
  started: 'inbox.followReason.started',
  replied: 'inbox.followReason.replied',
  mentioned: 'inbox.followReason.mentioned',
  responsible: 'inbox.followReason.responsible',
  /* 260.14: der ingen er satt som ansvarlig. */
  no_responsible: 'inbox.followReason.no_responsible',
  added: 'inbox.followReason.added',
  recipient: 'inbox.followReason.recipient',
  manual: 'inbox.followReason.manual',
};

/**
 * I varselet: «Du er ansvarlig». `no_responsible` er bookingvarslenes reserve — ingen er ansvarlig,
 * og du har «Få varsel om bud uten ansvarlig».
 */
export const NOTIFICATION_REASON_LABEL: Readonly<Record<string, TKey>> = {
  started: 'notifications.reason.started',
  replied: 'notifications.reason.replied',
  mentioned: 'notifications.reason.mentioned',
  responsible: 'notifications.reason.responsible',
  no_responsible: 'notifications.reason.no_responsible',
  added: 'notifications.reason.added',
  recipient: 'notifications.reason.recipient',
  manual: 'notifications.reason.manual',
};

/** Sakens steg, som i ordforrådet til engasjementet (0927). */
export const ENGAGEMENT_STATUS_LABEL: Readonly<Record<EngagementDto['status'], TKey>> = {
  not_asked: 'enums.engagement_status.not_asked',
  asked: 'enums.engagement_status.asked',
  answered: 'enums.engagement_status.answered',
  bid: 'enums.engagement_status.bid',
  verbally_confirmed: 'enums.engagement_status.verbally_confirmed',
  signed: 'enums.engagement_status.signed',
  played: 'enums.engagement_status.played',
  fell_through: 'enums.engagement_status.fell_through',
  cancelled: 'enums.engagement_status.cancelled',
};
